import { FC, memo, useMemo } from "react";
import DOMPurify from "dompurify";

function decodeHtml(html: string) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

const RateConditionsRenderer: FC<{ conditions: string[] }> = ({ conditions }) => {
  const sanitized = useMemo(
    () =>
      conditions
        .filter((c) => c && c.trim())
        .map((c) => {
          const hasHtml = /<[a-z][\s\S]*>/i.test(c);
          const content = hasHtml ? c : `<p>${c}</p>`;
          const decoded = decodeHtml(content);
          return DOMPurify.sanitize(decoded, {
            ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "ul", "ol", "li", "span", "div"],
            ALLOWED_ATTR: [],
          });
        }),
    [conditions],
  );

  if (sanitized.length === 0) return null;

  return (
    <div className="flex flex-col gap-4">
      {sanitized.map((html, i) => (
        <div key={i} className="border-s-border-subtle border-s-2 ps-4">
          <div
            className="[&>ol]:list-decimal [&>ol]:space-y-1 [&>ol]:ps-5 [&>ul]:list-disc [&>ul]:space-y-1 [&>ul]:ps-5"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      ))}
    </div>
  );
};

export default memo(RateConditionsRenderer);
